export default "__VITE_ASSET__487faf45__"